import { PropertyMapper } from '../../decorators';

export class LotStatus {
    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
